var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_2569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.79945 4.15363H20.2005C20.647 4.15363 21 4.51552 21 4.94979V5.96308H2V4.94979C2 4.50518 2.36339 4.15363 2.79945 4.15363Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53335 2.75775H18.3732C18.8197 2.75775 19.1727 3.11964 19.1727 3.55391V4.5672H3.72351V3.55391C3.72351 3.1093 4.0869 2.75775 4.52296 2.75775H4.53335Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2864 21.9173L6.85903 22C6.05958 22 5.36395 21.4417 5.21859 20.6558L2.71641 7.42098C2.64373 7.03841 2.93444 6.67652 3.32898 6.67652L19.6399 6.52142C20.0344 6.52142 20.3355 6.87297 20.2732 7.26588L17.8956 20.5731C17.7607 21.3486 17.0754 21.9276 16.2864 21.9276V21.9173Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3448 1H8.34372C7.99072 1 7.71039 1.27917 7.71039 1.63072V2.75775H8.39563V1.87888H14.2929V2.75775H14.9781V1.63072C14.9781 1.27917 14.6978 1 14.3448 1Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5519 21.1625C11.282 21.1625 11.0536 20.9454 11.0536 20.6662L10.9601 7.64845C10.9601 7.37962 11.1781 7.15215 11.4585 7.15215C11.7284 7.15215 11.9568 7.36928 11.9568 7.64845L12.0503 20.6662C12.0503 20.935 11.8322 21.1625 11.5519 21.1625Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1131 21.0694C15.1131 21.0694 15.0612 21.0694 15.03 21.0694C14.7601 21.0281 14.5732 20.7696 14.6251 20.5007L16.7951 7.65879C16.8366 7.38996 17.0962 7.20384 17.3661 7.25554C17.6361 7.2969 17.8229 7.55539 17.771 7.82423L15.6011 20.6662C15.5596 20.904 15.3519 21.0798 15.1131 21.0798V21.0694Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80383 21.1728C7.56503 21.1728 7.35738 20.997 7.31585 20.7592L5.14591 7.91728C5.10438 7.64845 5.28088 7.38995 5.55083 7.3486C5.82077 7.30724 6.08033 7.48301 6.12186 7.75185L8.29181 20.5938C8.33334 20.8626 8.15684 21.1211 7.88689 21.1625C7.85574 21.1625 7.83498 21.1625 7.80383 21.1625V21.1728Z",
    fill: "#414042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_2569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 21,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.36fb1acfe43e5694079fe5d9fc971a1e.svg";
export { ForwardRef as ReactComponent };